var MorphNav = {
    $el: $('[data-trigger="morph-nav"]'),

    init: function() {
        this.__initEventHandlers();
    },

    __initEventHandlers: function() {
        var $dropdowns = this.$el.find('.c-nav__item--children');
        $.each($dropdowns, function(index, value) { /* eslint-disable-line */
            var $item = $(this);
            var $itemDropdown = $item.find('.c-nav__morph-dropdown');
            var id = $itemDropdown.data('id');
            // var title = $itemDropdown.data('title');

            var $clone = $itemDropdown.clone();
                $clone.attr('class', 'c-morph-dropdown__submenu-list').attr('style', false);
                $clone.attr('data-title', null).attr('data-id', null);

            var $newElement = $('<li id="' + id + '" class="c-morph-dropdown__wrapper" data-content="' + id + '"></li>');
            $newElement.append('<div class="c-morph-dropdown__content"></div>');

            $newElement.find('.c-morph-dropdown__content').append( ( $clone ) );

            MorphNav.$el.find('.c-morph-dropdown .c-morph-dropdown__list > ul').append($newElement);

            if ( (index + 1) == $dropdowns.length ) {
                setTimeout(function() {
                    $(document).trigger('morphReady');
                }, 300);
            }
        });

        function morphDropdown(element) {
            this.element = element;
            this.mainNavigation = MorphNav.$el;
            this.mainNavigationItems = MorphNav.$el.find('.c-nav__item--children');
            this.dropdownList = MorphNav.$el.find('.c-morph-dropdown__list');
            this.dropdownListWrapper = MorphNav.$el.find('.c-morph-dropdown');
            this.dropdownWrappers = this.dropdownList.find('.c-morph-dropdown__wrapper');
            this.dropdownItems = this.dropdownList.find('.c-morph-dropdown__content');
            this.dropdownBg = this.dropdownList.find('.c-morph-dropdown__bg-layer');
            this.bindEvents();
        }

        morphDropdown.prototype.bindEvents = function() {
            var self = this;
            //hover over an item in the main navigation
            this.mainNavigationItems.mouseenter(function() { /* event */
                //hover over one of the nav items -> show dropdown
                self.showDropdown($(this));
            })
            .mouseleave(function() {
                setTimeout(function() {
                    //if not hovering over a nav item or a dropdown -> hide dropdown
                    if (self.mainNavigation.find('.c-nav__item--children:hover').length == 0 && self.element.find('.c-morph-dropdown__list:hover').length == 0) {
                        self.hideDropdown();
                    }
                }, 80);
            });

            this.dropdownWrappers.each(function() {
                $(this).find('.c-morph-dropdown__content').css('width', '300px');
            });

            // hover over the dropdown
            this.dropdownWrappers.mouseleave(function() {
                setTimeout(function() {
                    //if not hovering over a dropdown or a nav item -> hide dropdown
                    (self.mainNavigation.find('.c-nav__item--children:hover').length == 0 && self.element.find('.c-morph-dropdown__list:hover').length == 0 ) && self.hideDropdown();
                }, 50);
            });
        };

        morphDropdown.prototype.showDropdown = function(item) {
            var self = this;
            var selectedDropdown = this.dropdownList.find('#'+item.data('content')),
                selectedDropdownHeight = selectedDropdown.innerHeight(),
                selectedDropdownWidth = 300,
                selectedDropdownLeft = (item.offset().left + item.innerWidth() / 2 - selectedDropdownWidth / 2);

            //update dropdown position and size
            this.updateDropdown(selectedDropdown, parseInt(selectedDropdownHeight), selectedDropdownWidth, parseInt(selectedDropdownLeft));

            //add active class to the proper dropdown item
            this.element.find('.is-active').removeClass('is-active');
            selectedDropdown.addClass('is-active');
            item.addClass('is-active');

            //show the dropdown wrapper if not visible yet
            if( ! this.element.hasClass('is-dropdown-visible') ) {
                setTimeout(function() {
                    self.element.addClass('is-dropdown-visible');
                }, 50);
            }
        };

        morphDropdown.prototype.updateDropdown = function(dropdownItem, height, width, left) {
            this.dropdownList.css({
                '-moz-transform': 'translateX(' + left + 'px)',
                '-webkit-transform': 'translateX(' + left + 'px)',
                '-ms-transform': 'translateX(' + left + 'px)',
                '-o-transform': 'translateX(' + left + 'px)',
                'transform': 'translateX(' + left + 'px)',
                'width': width+'px',
                'height': height+'px',
            });

            this.dropdownBg.stop().animate({
                'width': width+'px',
                'height': height+'px',
            }, 150);
        };

        morphDropdown.prototype.hideDropdown = function() {
            this.element.removeClass('is-dropdown-visible').find('.is-active').removeClass('is-active').end();
        };

        morphDropdown.prototype.resetDropdown = function() {
            this.dropdownList.removeAttr('style');
        };

        var morphDropdowns = [];
        var resizing = false;

        function updateDropdownPosition() {
            morphDropdowns.forEach(function(element){
                element.resetDropdown();
            });

            resizing = false;
        }

        $(document).on('morphReady', function() {
            morphDropdowns.push(new morphDropdown(MorphNav.$el));
            updateDropdownPosition();
            $(window).on('resize', function() {
                if ( !resizing ) {
                    resizing = true;
                    (!window.requestAnimationFrame) ? setTimeout(updateDropdownPosition, 300) : window.requestAnimationFrame(updateDropdownPosition);
                }
            });
        });
    },
}

export default MorphNav;



// WEBPACK FOOTER //
// ./scripts/components/morph-nav.js